import { render, staticRenderFns } from "./CadastroAnexoRequerido.vue?vue&type=template&id=1dcca064&"
import script from "./CadastroAnexoRequerido.vue?vue&type=script&lang=js&"
export * from "./CadastroAnexoRequerido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports